import { GetterTree } from 'vuex'
import { UIState } from './types'
import { RootState } from '../types'
export const getters: GetterTree<UIState, RootState> = {
  amountOfThing(state) {
    return state.amountOfThings
  },
  clusterCreated(state) {
    return state.clusterCreated
  },
  selectionItemInDetail: state => state.selectionItemInDetail,
  drawerComponent: state => state.drawerComponent,
  drawer: state => state.drawer,
  mainGridLoading(state) {
    return state.mainGridLoading
  },
  follow: state => state.follow,
  showCluster(state) {
    return state.showCluster
  },
  showEntityName(state) {
    return state.showEntityName
  },
  showEntityType(state) {
    return state.showEntityType
  },
  showThingInfo(state) {
    return state.showThingInfo
  },
  showSnackbar(state) {
    return state.showSnackBar
  },
  snackBarText(state) {
    return state.snackBarText
  },
  snackBarButtonClose(state) {
    return state.snackBarButtonClose
  },
  thingInfo(state) {
    return state.thingInfo
  },
  trailView(state) {
    return state.trailView
  },
  temperatureByTimeView(state) {
    return state.temperatureByTimeView
  },
  getFollowTimerIsActive(state) {
    return state.followTimerIsActive
  }
}
